import { useRouter } from "next/router";
import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { setInitialRequestorConfig } from "shared/lib/requestorFunctions";
import * as Logger from "shared/services/Logger";

import PageSeo from "@components/Utils/PageSeo";

import Custom404Page from "./404";

interface IPageProps {
  pageNotFound?: boolean;
}

const Homepage = ({ pageNotFound }: IPageProps) => {
  const router = useRouter();
  const { menuItems, downloadedPages } = useSelector((state: AppState) => ({
    menuItems: state.requestorConfig.menuItems,
    downloadedPages: state.requestorConfig.downloadedPages,
  }));

  const url = Array.isArray(router.query.url)
    ? router.query.url[0]
    : router.query.url;

  const title =
    url &&
    menuItems.length > 0 &&
    menuItems.find((menuItem) => menuItem.url === url)?.label;

  const pageContent = url ? downloadedPages[url] : "";

  if (pageNotFound) {
    return <Custom404Page />;
  }

  return (
    <div className="container">
      {title && <PageSeo title={{ defaultTitle: title }} />}
      <div
        className="universal-content-box"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: pageContent,
        }}
      />
    </div>
  );
};

Homepage.getInitialProps = async (initialProps) => {
  try {
    const { domain } = await setInitialRequestorConfig(initialProps);

    const fileServerPagesToDownload = [initialProps.query.url];

    return { domain, fileServerPagesToDownload };
  } catch (e) {
    Logger.error("Error Initial. ", e);
    return {};
  }
};

export default Homepage;
